const TOKEN_KEY = "fitlog_api_token";

export function getApiToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || "";
  } catch {
    return "";
  }
}

export function saveApiToken(token) {
  try {
    localStorage.setItem(TOKEN_KEY, token.trim());
  } catch {}
}

export function clearApiToken() {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {}
}

export async function apiFetch(url, options = {}) {
  const headers = new Headers(options.headers || {});
  const token = getApiToken();
  if (token && !headers.has("Authorization")) {
    headers.set("Authorization", "Bearer " + token);
  }

  const res = await fetch(url, { ...options, headers });
  if (res.status === 401) {
    clearApiToken();
    window.dispatchEvent(new Event("fitlog:auth-required"));
  }
  return res;
}
